import MarkupPage from "../components/markupPage"

const Council = () => {
    const url = "student-hub/student-representative-council/"
    return (
        <MarkupPage url={url} />
    )
}

export default Council